import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function render() {
  const god = document.querySelector(".c-god");
  const gradient = document.querySelector(".c-god__gradient");
  const timeline = document.querySelector(".l-timeline");
  const line = timeline.querySelector(".l-timeline__divider");
  const els = timeline.querySelectorAll(".c-domain");

  els.forEach((elmt) => {
    const content = elmt.querySelector(".c-domain__content");
    const effects = elmt.querySelectorAll(".c-domain__effect");
    const icon = elmt.querySelector(".c-domain__icon");
    const jobs = elmt.querySelectorAll(".c-domain__jobs > *");
    const title = elmt.querySelector(".c-domain__title");

    let showIcon = gsap.timeline({
      paused: true,
      onComplete: () => {
        icon.addEventListener("mouseenter", enter);
        icon.addEventListener("mouseleave", leave);
      }
    });
    showIcon
      .to(icon, {
        duration: 0.4,
        ease: "Back.easeOut",
        scale: 1,
      })
      .from(
        effects,
        {
          duration: 0.4,
          top: "50%",
        },
        0.1
      );

    gsap.timeline({
      scrollTrigger: {
        end: "top 80%",
        onEnter: () => showIcon.play(),
        onLeaveBack: () => {
          icon.removeEventListener("mouseenter", enter);
          icon.removeEventListener("mouseleave", leave);
          showIcon.reverse()
        },
        scroller: ".smooth-scroll",
        start: "top 80%",
        trigger: content,
      },
    });

    let fillIcon = gsap.timeline({ paused: true });
    fillIcon.to(effects, {
      duration: 1,
      ease: "Power1.easeIn",
      top: "-=60%",
    });

    function enter () {
      fillIcon?.play();
    }

    function leave () {
      fillIcon?.reverse();
    }


    let textHighlight = gsap.timeline({
      paused: true,
      scrollTrigger: {
        end: "bottom 60%",
        scroller: ".smooth-scroll",
        scrub: true,
        start: "top 60%",
        trigger: elmt,
      },
    });
    textHighlight
      .to(title, {
        opacity: 1,
        scale: 1,
      })
      .to(jobs, {
        ease: "Circ.easeOut",
        opacity: 1,
        stagger: {
          each: 0.2,
        },
      })
      .to(god, {
        ease: "Circ.easeOut",
        opacity: 1,
      });
  });

  let drawLine = gsap.timeline({
    scrollTrigger: {
      end: "bottom 75%",
      scroller: ".smooth-scroll",
      scrub: true,
      start: "top 75%",
      trigger: timeline,
    },
  });
  drawLine.to(line, {
    ease: "linear",
    height: "100%",
  });
}
